import { fetcher } from '@commenda/utils';

import { IApiResponse } from './types';

export interface IBatchTrashFilePlacementsParams {
  filePlacementIds: string[];
}

export async function batchTrashFilePlacements({
  filePlacementIds,
}: IBatchTrashFilePlacementsParams): Promise<IApiResponse<null>> {
  const response = await fetcher('drive-view/file-placement/trash/bulk', {
    method: 'POST',
    body: { filePlacementIds },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to trash placements',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
